import React from 'react';
import { Modal, Row, Col } from 'antd';
import VideoRenderer from '../player/renderers/VideoRenderer';
import ImageRenderer from '../player/renderers/ImageRenderer';
import WebRenderer from '../player/renderers/WebRenderer';
import WidgetRenderer from '../player/renderers/WidgetRenderer';
import HLSRenderer from '../player/renderers/HLSRenderer';
import VideoURLRenderer from '../player/renderers/VideoURLRenderer';

class MediaPreviewPopup extends React.Component {
    state = {
        previewVisible: false,
        previewMediaData: null
    };

    constructor(props) {
        super(props);
    }

    previewMedia = (mediaData) => {
        this.showPreviewMedia(mediaData)
    }


    showPreviewMedia = (data = null, doShow = true) => {
        return new Promise((resolve, reject) => {
            this.setState({ previewMediaData: data, previewVisible: doShow }, () => { resolve() });
        })
    }

    clostPreview = () => {
        this.showPreviewMedia(null, false);
    }

    render() {
        const currentContent = this.state.previewMediaData;

        if (!currentContent) {
            return null;
        }

        const { FileType = "", MediaType = "File", FileTypeSub = "" } = currentContent;

        const type = FileType.toLocaleLowerCase();
        var renderMedia = null;
        var mediaType = type.split("/")[0];
        var mediaTypeSub = FileTypeSub.toLocaleLowerCase();

        switch (MediaType) {
            case "Widget":
                renderMedia = <WidgetRenderer data={currentContent}></WidgetRenderer>
                break;
            default:

                switch (mediaType) {
                    case "image":
                        renderMedia = <ImageRenderer data={currentContent}></ImageRenderer>
                        break;
                    case "video":
                        renderMedia = <VideoRenderer data={currentContent}></VideoRenderer>
                        break;
                    case "web":
                        renderMedia = <WebRenderer data={currentContent}></WebRenderer>
                        break;
                    case "videourl":
                        renderMedia = <VideoURLRenderer data={currentContent}></VideoURLRenderer>
                        break;
                    case "streamingurl":
                        switch (mediaTypeSub) {
                            case "hls":
                                renderMedia = <HLSRenderer src={currentContent.UploadFile}></HLSRenderer>
                                break;
                        }
                        break;
                }
                break;
        }

        if (!renderMedia) {
            return null;
        }


        return (

            <Modal
                className="dark-modal"
                title=""
                centered
                open={this.state.previewVisible}
                footer={null}
                onOk={() => this.clostPreview()}
                onCancel={() => this.clostPreview()}
                wrapClassName="modal-window"
                width={800}
            >
                <Row justify="space-around" align="middle" >
                    <Col style={{ width: "700px", height: "500px" }}>
                        <div style={{ width: '100%', height: '100%' }}>
                            {renderMedia}
                        </div>
                    </Col>
                </Row>
            </Modal>
        )
    }
}

export default MediaPreviewPopup